export default "__VITE_ASSET__D11QcJpV__"